// refactored from https://github.com/appleboy/react-recaptcha/blob/master/src/index.js
import { useState, useEffect } from 'react';
import { useScript } from './useScript';

export const RECAPTCHA_SCRIPT_SRC_URL =
  'https://www.google.com/recaptcha/api.js?render=explicit';

const XM_RECAPTCHA_SITEKEY = '6Lfev_4ZAAAAAEoum39P2rQKpRLU7OWlSFlzc7G-';
const AUTOMATION_SITEKEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';

let timer;

/**
 * a hook integrates google-recaptcha v2 into react function components
 * @param {String} containerId  ID of the container to render the reCAPTCHA widget
 * @param {Function} successCallback executed when the user submits a successful response and passes the challenge if it prompts up. The g-recaptcha-response token is passed to the callback.
 * @return {Object}
 */
export function useRecaptcha(containerId, successCallback) {
  // https://stackoverflow.com/questions/45240833/what-are-the-benefits-of-explicitly-rendering-recaptcha-widget-as-opposed-to-aut
  // explicit rendering is needed because the view template of applicatio may not be loaded yet when recaptcha is loaded
  useScript(RECAPTCHA_SCRIPT_SRC_URL);
  const [recaptchaLoaded, setRecaptchaLoaded] = useState(
    window?.grecaptcha?.render ? true : false,
  );
  const [recaptchaWidget, setRecaptchaWidget] = useState(null);

  useEffect(() => {
    timer = window.setInterval(() => {
      if (window?.grecaptcha?.render) {
        setRecaptchaLoaded(true);
      }
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    if (recaptchaLoaded && recaptchaWidget === null) {
      clearInterval(timer);
      const widget = window.grecaptcha.render(containerId, {
        sitekey:
          window?.localStorage?.xmAutomationMode === 'true'
            ? AUTOMATION_SITEKEY
            : XM_RECAPTCHA_SITEKEY,
        size: 'invisible',
        callback: successCallback,
      });
      setRecaptchaWidget(widget);
    }
  }, [recaptchaLoaded, successCallback, recaptchaWidget, containerId]);

  return {
    recaptchaLoaded,
    recaptchaWidget,
  };
}
